import React, { useState } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import analytics from "analytics/analytics";
import style from "./ventory-menu.css";
import VentoryNavMenu from "./ventory-nav-menu";
import { gender, genderShort } from "./constants";


function VentoryMenu({ data }) {
    const [selectedGender, setSelectedGender] = useState(null);

    if (selectedGender) {
        return (
            <VentoryNavMenu
                data={data}
                selectedGender={selectedGender}
                onCloseClick={() => {
                    analytics.event("ventory nav", "close");
                    setSelectedGender(null);
                    toggleBodyScrollLock(false);
                }}
            />
        );
    } else {
        return (
            <div className={style.container}>
                <div className={style.content}>
                    <h4 className={classnames(style.description, style.subHeader)}>
                        Your fashion searches in one place
                    </h4>
                    <h3 className={style.description}>Start shopping</h3>
                    <div className={style.buttonContainer}>
                        <button
                            className={style.genderButton}
                            onClick={() => onGenderButtonClick(false)}
                        >
                            Women
                        </button>
                        <button
                            className={style.genderButton}
                            onClick={() => onGenderButtonClick(true)}
                        >
                            Men
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    function toggleBodyScrollLock(lock = true) {
        const body = document.querySelector("body");
        if (lock) {
            body.style.position = "fixed";
            body.style.height = "100%";
        } else {
            body.style = null;
        }
    }

    function onGenderButtonClick(isMale) {
        analytics.event(
            "ventory nav",
            "start",
            `${isMale ? gender.men.toLowerCase() : gender.women.toLowerCase()}`
        );
        setSelectedGender(isMale ? genderShort.men : genderShort.women);
        toggleBodyScrollLock(true);
    }
}

export default VentoryMenu;

VentoryMenu.propTypes = {
    data: PropTypes.object.isRequired
};
